import gql from 'graphql-tag'

import reviewFragment from '../fragments/review-fragment'

const upsertReviewMutation = gql`
  mutation upsertReview($productId: ID!, $title: String!, $comment: String!, $rating: Int!) {
    upsertReview(input: { productId: $productId, title: $title, comment: $comment, rating: $rating }) {
      review {
        ...review
      }
    }
  }
  ${reviewFragment}
`

export default upsertReviewMutation
